import { NodeForm } from '@/components/nodes/NodeForm'
import { WorkspaceFormValues } from '@/lib/validations/workspace'
import type { User, Workspace } from '@/types'
import { nodeFormConfigs } from '@/lib/config/node-form-configs'

interface WorkspaceFormProps {
  mode?: 'create' | 'edit'
  defaultValues?: Partial<WorkspaceFormValues>
  workspace?: Workspace // For edit mode
  currentUser?: User | null
  logo?: string
  onLogoChange: (logo: string | undefined) => void
  currentUsers?: User[]
  usersToAdd: User[]
  usersToRemove: string[]
  availableUsers: User[]
  onAddUser: (userId: string) => void
  onRemoveUserToAdd: (userId: string) => void
  onRemoveCurrentUser?: (userId: string) => void
  onSubmit: (data: WorkspaceFormValues) => void | Promise<void>
  onCancel: () => void
  submitText: string
  cancelText?: string
  loading?: boolean
  title: string
  description?: string
  onDirtyChange?: (isDirty: boolean) => void
  simplified?: boolean // Hide team member associations for onboarding
}

export function WorkspaceForm({
  mode = 'create',
  defaultValues,
  logo,
  onLogoChange,
  currentUsers = [],
  usersToAdd,
  usersToRemove,
  availableUsers,
  onAddUser,
  onRemoveUserToAdd,
  onRemoveCurrentUser,
  onSubmit,
  onCancel,
  submitText,
  cancelText,
  loading = false,
  title,
  description,
  onDirtyChange,
  simplified = false,
}: WorkspaceFormProps) {
  const handleSubmit = async (data: Record<string, unknown>) => {
    await onSubmit(data as unknown as WorkspaceFormValues)
  }

  const config = simplified ? nodeFormConfigs.workspaceSimplified : nodeFormConfigs.workspace

  return (
    <NodeForm
      mode={mode}
      config={config}
      initialData={defaultValues}
      onSubmit={handleSubmit}
      onCancel={onCancel}
      submitText={submitText}
      cancelText={cancelText}
      loading={loading}
      title={title}
      description={description}
      onDirtyChange={onDirtyChange}
      simplified={simplified}
      // Workspace-specific props
      logo={logo}
      onLogoChange={onLogoChange}
      currentUsers={currentUsers}
      usersToAdd={usersToAdd}
      usersToRemove={usersToRemove}
      availableUsers={availableUsers}
      onAddUser={onAddUser}
      onRemoveUserToAdd={onRemoveUserToAdd}
      onRemoveCurrentUser={onRemoveCurrentUser}
    />
  )
}
